import axios from 'axios'
import { ElLoading, ElMessageBox } from 'element-plus'
import router from '../router'

let baseURL
if (process.env.NODE_ENV === 'production') {
  // 旧代码：根据访问IP自动选择后端（已注释）
  // // baseURL = 'http://39.99.176.179:20202/'
  // // baseURL = 'http://47.115.226.9:20202/'
  // // 生产环境：根据访问IP自动选择
  // if (typeof window !== 'undefined' && window.location.host.includes('172.20.42.80')) {
  //   // 内网环境
  //   baseURL = 'http://172.20.42.80:20202/'
  // } else {
  //   // 外网环境
  //   baseURL = 'http://47.115.226.9:20202/'
  // }

  // 新代码：生产环境统一使用相对路径，由nginx代理到后端
  baseURL = '/'
} else {
  // 开发环境：使用相对路径，由vue.config.js代理到后端
  // baseURL = 'http://10.10.16.110:20202/'
  // baseURL = 'http://127.0.0.1:20202/'
  baseURL = '/'
}
// 创建axios实例
const service = axios.create({
  baseURL: baseURL,
  timeout: 360000
})
let loading

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 请求开始时显示加载状态
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    // 新增配置项，默认不显示加载状态
    const showLoading = config.showLoading || false
    if (showLoading) {
      loading = ElLoading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 将加载实例保存到请求配置中
      config.loading = loading
    }
    return config
  },
  (error) => {
    // 请求错误处理
    if (loading) {
      loading.close()
    }
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 请求成功处理
    if (response.config.loading) {
      response.config.loading.close()
    }
    return response.data
  },
  (error) => {
    // 请求失败处理
    console.log(error, 'error>>>>>')
    if (error.response) {
      if (error.response.data) {
        if (error.response.data.message) {
          if (error.response.data.message === 'Token has expired' || error.response.data.message === 'Invalid token') {
            sessionStorage.removeItem('token')
            router.push('/')
          } else {
            console.log('=======')
            ElMessageBox.alert(error.response.data.message, '', {
              confirmButtonText: 'OK',
              callback: () => {

              }
            })
          }
        } else {
          let val = ''
          if (error.response.data.error) {
            val = error.response.data.error
          } else {
            val = '服务器内部错误，请联系系统开发人员'
          }
          ElMessageBox.alert(val, '', {
            confirmButtonText: 'OK',
            callback: () => {
            }
          })
        }
      }
    } else {
      ElMessageBox.alert('操作失败', '', {
        confirmButtonText: 'OK',
        callback: () => {
          // router.push('/')
        }
      })
    }

    if (error.config.loading) {
      error.config.loading.close()
    }
    return Promise.reject(error)
  }
)

export default service
